import { Avatar, styled, DialogTitle } from "@mui/material";

export const ProfileImage = styled(Avatar)`
  width: 143px;
  height: 143px;
  margin: 0 auto;
  @media (max-width: 768px) {
    width: 100px;
    height: 100px;
    margin: 0;
  }
`;

export const DialogHeader = styled(DialogTitle)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e9ebec;
  margin-bottom: 16px;
  font-weight: 700;
  font-size: 24px;
`;
